import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { PapsServiceColor } from "config/status";
import { COLORS } from "constants/colors";
import { PapsService } from "generated/graphql";

export const REQUEST_COLORS = {
  [PapsService.Mad]: "#2f80ed",
  [PapsService.Nt]: "#394fbf",
  [PapsService.Tr]: "#2ba815",
  ...PapsServiceColor,
};
interface StyleProps {
  color?: string;
}

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: "#f5f6f8",
      display: "flex",
      width: "100%",
      marginBottom: 0,
    },
    left: {
      margin: theme.spacing(2),
    },
    top: {
      flex: 1,
      display: "flex",
      justifyContent: "space-between",
      marginTop: "12px",
    },
    filterStyle: {
      color: COLORS.primary,
      fontFamily: "Montserrat",
      fontWeight: "bold",
    },
    bottom: {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      backgroundColor: COLORS.white,
      borderRadius: "12px",
      padding: "15px",
      paddingBottom: "76px",
    },
    grid: {
      width: 300,
      height: 180,
      borderRadius: 20,
      backgroundColor: COLORS.white,
      marginLeft: 10,
      marginRight: 10,
    },
    title: {
      textAlign: "left",
      display: "flex",
      justifyContent: "space-between",
      marginTop: 20,
      marginBottom: 15,
    },
    searchDate: {
      justifyContent: "center",
      alignItems: "center",
    },
    table: {
      display: "grid",
      " & .MuiTableRow-head": {
        "& .MuiTableCell-head:first-child": {
          paddingLeft: "20px",
          borderBottomLeftRadius: "5px",
          borderTopLeftRadius: "5px",
        },
        "& .MuiTableCell-head:nth-last-child": {
          borderBottomRightRadius: "5px",
          borderTopRightRadius: "5px",
        },
        "& .MuiTableCell-head:last-child": {
          borderBottomRightRadius: "5px",
          borderTopRightRadius: "5px",
          border: "none",
        },
      },
      " & .MuiTableRow-root": {
        "& > td": {
          paddingBottom: "6px",
          paddingTop: "6px",
          borderTop: "1px solid rgba(64, 180, 229, 0.25)",
          borderBottom: "1px solid rgba(64, 180, 229, 0.25)",
        },
        "& .MuiTableCell-root:first-child": {
          borderRadius: "10px 0px 0px 10px",
          borderLeft: "1px solid rgba(64, 180, 229, 0.25)",
          borderRight: "none",
          marginTop: "50px",
        },
        "& .MuiTableCell-root:last-child": {
          borderRight: "1px solid rgba(64, 180, 229, 0.25)",
        },
      },
      "& .MuiTableCell-head": {
        marginBottom: "1em",
        height: "50px",
        backgroundColor: COLORS.lightBlue,
        color: COLORS.primary,
      },
      "& .MuiTableRow-head .MuiTableCell-head:first-child": {
        border: "none !important",
      },
      "& .MuiTableRow-root": {
        height: 30,
      },
    },
  })
);
